

































































































































































import moment from "moment/moment";
import { mixins } from "vue-class-component";
import { Component } from "vue-property-decorator";
import MyMixin from "@/mixins/datemixin";
import { Site } from "@/shared/Site";
import DateType from "@/shared/DateType";
import ExpandableDateChooser from "@/components/expansion/expandableDateChooser.vue";
import ExpandableListeSites from "@/components/expansion/expandableListeSites.vue";
import ExpandableTotal from "@/components/expansion/expandableTotal.vue";
import NumberTmpl from "@/ui-component/number.vue";
import VueJsonToCsv from "vue-json-to-csv";
import MobileMixin from "@/mixins/mobileMixin";
import { ChartOptions } from "@/charts/graphData";
import Doughnut from "@/charts/Doughnut.vue";
import CoffreMixin from "@/mixins/coffreUtils";
import ErrorMixin from "@/mixins/errorMixins";

@Component({
  components: {
    ExpandableDateChooser,
    ExpandableListeSites,
    ExpandableTotal,
    NumberTmpl,
    VueJsonToCsv,
    Doughnut,
  },
})
export default class Repartitions extends mixins(
  MyMixin,
  CoffreMixin,
  MobileMixin,
  ErrorMixin
) {
  public dateType: DateType = new DateType();
  public dataGetted = false;
  public selectedSites: Site[] = new Array();
  public totalData = {
    totalAnnulations: 0,
    nbrAnnulations: 0,
    taux: 0,
    isAnnulations: true,
  };
  public recus = new Array();
  public loadData = false;
  public showRecu = false;
  public search = {
    types: 0,
    typeRepartition: "ANNULATION",
    type: "CAISSIER",
    site: this.sites[0].restaurantId,
    start: "",
    end: "",
  };
  public CATotal: number = 0;
  public AnnulTotal: number = 0;
  public correctionsTotal: number = 0;
  public openedPans = -1;
  public headers = new Array();
  public optionsTable = {
    sortBy: ["taux"],
  };
  public options: ChartOptions = new ChartOptions();
  public labels: Array<string> = [];
  public data: Array<number> = [];
  public optionsBar: ChartOptions = new ChartOptions();
  public labelsBar: Array<string> = [];
  public dataBar: Array<number> = [];
  public colors = [
    "#FF5252",
    "#BDC3C7",
    "#52B3D9",
    "#F4B350",
    "#7E349D",
    "#03C9A9",
    "#C0392B",
    "#2574A9",
    "#6C7A89",
    "#1EBC61",
    "#BD02B0",
    "#0057A0",
    "#1EBC61",
    "#870000",
  ];

  public mounted() {
    this.search.start = this.formatDateSend(new Date());
    this.headers = this.getAnnulationsHeaders();
    const dateFin = moment().add("d", 1).toDate();
    this.search.end = this.formatDateSend(dateFin);
    this.search.site = this.sites[0].restaurantId;
    this.selectedSites = new Array();
    this.selectedSites.push(this.sites[0]);
  }

  /**
   * methode de mise a jour de la date modifié dans l'expandable panel
   * @param date {DateType} - la date dans le format du datepicker
   */
  public updateDate(date: DateType) {
    this.dateType = date;
    if (date.dateFin && date.dateDebut) {
      this.search.start = this.formatDateSend(date.dateDebut);
      const dateFin = moment(date.dateFin).add("d", 1).toDate();
      this.search.end = this.formatDateSend(dateFin);
    }
  }
  /**
   * methode  de mise a jour du site selectionné
   * @param site {Site} - le site à selectionner
   */
  public addSite(site: Site) {
    this.selectedSites = [];
    this.selectedSites.push(site);
    this.search.site = site.restaurantId;
  }
  /**
   * methode permettant de faire disparaitre le dialogue contenant le rapport
   */
  public hide(target: any) {
    this.showRecu = false;
  }
  /**
   * méthode de récueparation des recus concernés
   */
  public getRecus() {
    this.loadData = true;
    this.$store.dispatch("analyses/getRepartitions", this.search).then(
      (data: any) => {
        // console.log(data);
        // this.recus = data;
        this.orderData(data);
        this.loadData = false;
        // this.$store.dispatch("login/setLoading", false);
      },
      (error: any) => {
        console.log(error);
        this.setErrorFromTxt(error.toString());
        this.loadData = false;
        // this.$store.dispatch("login/setLoading", false);
      }
    );
  }
  /**
   * méthode de mise en forme des resultats et de calcul des taux
   */
  private orderData(data: any) {
    this.totalData.isAnnulations = this.search.typeRepartition === "ANNULATION";
    this.CATotal = data.reduce((a: any, b: any) => a + (b["ca"] || 0), 0);
    this.AnnulTotal = data.reduce(
      (a: any, b: any) => a + (b["montantAnnulation"] || 0),
      0
    );
    this.correctionsTotal = data.reduce(
      (a: any, b: any) => a + (b["montantCorrection"] || 0),
      0
    );

    const nbrAnnulations = data.reduce(
      (a: any, b: any) => a + (b["nbrAnnulation"] || 0),
      0
    );
    const nbrCorrections = data.reduce(
      (a: any, b: any) => a + (b["nbrCorrection"] || 0),
      0
    );

    const annulations = data.filter((ligne: any) =>
      this.search.typeRepartition === "ANNULATION"
        ? ligne.montantAnnulation > 0
        : ligne.montantCorrection > 0
    );
    annulations.map((ligne: any) => {
      ligne.repart =
        this.search.typeRepartition === "ANNULATION"
          ? (ligne.montantAnnulation / this.AnnulTotal) * 100
          : (ligne.montantCorrection / this.correctionsTotal) * 100;
      ligne.taux =
        this.search.typeRepartition === "ANNULATION"
          ? (ligne.montantAnnulation / ligne.ca) * 100
          : (ligne.montantCorrection / ligne.ca) * 100;
      ligne.tauxCa = (ligne.ca / this.CATotal) * 100;
    });
    this.recus = annulations;
    if (this.search.typeRepartition === "ANNULATION") {
      this.headers = this.getAnnulationsHeaders();
    } else {
      this.headers = this.getCorrectionsHeaders();
    }
    this.makeChart();
    this.totalData.totalAnnulations =
      this.search.typeRepartition === "ANNULATION"
        ? this.AnnulTotal
        : this.correctionsTotal;
    this.totalData.nbrAnnulations =
      this.search.typeRepartition === "ANNULATION"
        ? nbrAnnulations
        : nbrCorrections;
    this.totalData.taux = this.totalData.totalAnnulations / this.CATotal;
    this.loadData = false;
  }
  /**
   * creation d'un graph avec les données de repartitions
   */
  private makeChart() {
    const graphTitle =
      this.$t("repartitions") +
      " " +
      this.$t(this.search.typeRepartition.toLowerCase()) +
      " " +
      this.$t(this.search.type.toLowerCase());
    this.options.setTitleTxt(graphTitle);
    const donnee = new Array();
    const labels = new Array();
    // $scope.graph.data = [];
    this.recus.map((annulation: any) => {
      donnee.push(annulation.repart);
      labels.push(annulation.libelle);
    });
    this.labels = labels;
    this.data = donnee;
    this.options.makeMeAPercentDoughnut();
    this.dataGetted = true;
  }

  /*private makeBarChart() {
        const graphTitleB = this.$t("CA") + "/ " + this.$t(this.search.typeRepartition.toLowerCase()) + " " + this.$t(this.search.type.toLowerCase());
        this.optionsBar.setTitleTxt(graphTitleB);
        this.dataBar = {series: ['%ca', '%annulations']};
        var data = [];
        var labelsB = [];
        var dataCa = [];
        var dataAnnul = [];
        angular.forEach(annulations, function (annulation) {
            dataCa.push(annulation.tauxCa);
            dataAnnul.push(annulation.repart);
            labelsB.push(annulation.libelle);
        });
        data.push(dataCa);
        data.push(dataAnnul);
        $scope.graphBars.labels = labelsB;
        $scope.graphBars.data = data;
    }*/

  get sites(): Site[] {
    return this.$store.getters["login/sites"];
  }
}
